import { usersApi } from 'entities/users';
import { toast } from 'react-toastify';

const createActivityApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    createActivity: builder.mutation({
      query: (form: any) => ({
        url: '/promo-b2b/admin/promo-b2b/admin/activities/',
        method: 'POST',
        body: form,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно добавили новую акцию', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    updateActivity: builder.mutation({
      query: ({ id, body }) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно изменили акцию', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
    deleteActivity: builder.mutation<any, number>({
      query: (id) => ({
        url: `/promo-b2b/admin/promo-b2b/admin/activities/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Вы успешно удалили акцию', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return ['User'];
      },
    }),
    uploadActivityImage: builder.mutation<{ file_path: string }, FormData>({
      query: (formData) => ({
        url: '/promo-b2b/admin/promo-b2b/admin/activities/upload-image/',
        method: 'POST',
        body: formData,
      }),
    }),
  }),
});

export const { useCreateActivityMutation, useUpdateActivityMutation, useDeleteActivityMutation, useUploadActivityImageMutation } = createActivityApi;
